var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.emptylist || _vm.emptylist.length<=0)?_c('div',{staticClass:"emptybox"},[_c('img',{attrs:{"src":require("@/images/empty.png")}}),_c('div',[_vm._v(_vm._s(_vm.emptytext))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }